export default [
    {
        name: "name",
        label: "Name",
        type: "string",
        helpText: "Tag's name",
        errorMessage: "Tag's name is required",
        validation: {
            required: true,
        },
    },
];
